module.exports = __webpack_public_path__ + "assets/4bfd8f99ec815fa434ede9d9a9412163.mp4";